import { ThemeProvider, Typography, useTheme } from "@mui/material";
import { PaintMarker } from "../mapa";
import { divIcon, Marker } from "leaflet";
import pontoEncontro from "../../assets/PontoDeEncontro.png";

export interface PontoEncontroData {
  id: number;
  idZas: number;
  lat: number;
  lon: number;
  ponto: string;
  popEstimada: number;
  areaUtil: number;
  obs?: string;
  dataCadastro: Date;
  idModificou?: string;
  dataModificacao?: Date;
}

export class PontoEncontro extends Marker<PontoEncontroData> {
  private heightGeom = 50;
  public paintOptions: PaintMarker;

  public properties: PontoEncontroData;

  constructor(properties: PontoEncontroData, paintOptions: PaintMarker) {
    super([properties.lat, properties.lon], paintOptions);
    this.paintOptions = paintOptions;
    this.properties = properties;

    this.setIcon(divIcon({
      html: this.iconComponent(),
      className: '',
      iconAnchor: [(this.paintOptions.iconSize ?? 20) / 2, this.heightGeom / 2],
    }));

    if (paintOptions.bindTooltip ?? true) {
      this.bindTooltip(this.popUpComponent());
    }

    // if (paintOptions.bindPopUp ?? true) {
    //   this.bindPopup(this.popUpComponent(), {
    //     className: "",
    //     maxWidth: 390,
    //     offset: [(paintOptions.iconSize ?? 20) / 2, 0],
    //   });
    // }
  }


  public iconComponent() {
    const component: JSX.Element = (<IconData
      iconSize={this.paintOptions.iconSize ?? 15}
      text={this.properties.ponto}
    />
    );
    return window.JSXToHTML(component);
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        width: "15em",
        height: "8em",
        display: "flex",
        overflowY: "auto",
        justifyItems: "center",
        flexDirection: "column",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>{this.properties.ponto}</Typography>
        <Row title="Latitude" value={this.properties.lat.toSignificantDigits('latStr')} />
        <Row title="Longitude" value={this.properties.lat.toSignificantDigits('lonStr')} />
        <Row title="População Estimada" value={this.properties.popEstimada.toString()} />
        <Row title="Área Útil (m²)" value={this.properties.areaUtil.toSignificantDigits("metros")} />
      </div>
    );
  }
}

interface PropsIcon {
  text: string;
  iconSize: number;
}
const IconData: React.FC<PropsIcon> = ({ iconSize, text }) => {
  const theme = useTheme();

  return <ThemeProvider theme={theme}>
    <img
      src={pontoEncontro}
      alt={text}
      style={{
        objectFit: "contain",
        height: `${iconSize}px`,
        width: `${iconSize}px`,
      }}
    />
  </ThemeProvider>;
};

interface PropsRow {
  title: string;
  value: string;
}
const Row: React.FC<PropsRow> = (data) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "1.5em",
      padding: "5px",
      borderRadius: "5px",
    }}>
      <Typography fontSize={"1em"} fontWeight={"bold"}>{data.title}</Typography>
      <div style={{ minWidth: "5px", flex: 1 }} />
      <Typography fontSize={"1em"}>{data.value}</Typography>
    </div>
  );
};